import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({ title, description, path, type = "website" }) => {
  const siteName = "Welkom Winder Services";
  const baseUrl = "https://www.winderservices.com";
  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  const fullUrl = `${baseUrl}${path || ""}`;
  const desc = description || "Trusted electrical, mechanical, and mining engineering solutions across Africa since 1999.";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={fullUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content={siteName} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
    </Helmet>
  );
};

export default SEO;
